import { h } from 'preact'
import { useLayoutEffect } from 'preact/hooks'
import { setAllToMaxHeight } from '../../js/modules/setAllToMaxHeight.js'

export const MagTv = ({ title, item_portrait, items_landscape, cacheKey, CTA, device }) => {
   useLayoutEffect(() => {
      if (device !== 'mobile') {
         setAllToMaxHeight('.js-magtv-thumb')
      }
   }, [])

   return (
      <div class="container-fluid">
         <div class="row mb-4" id="magtv" data-cache-key={cacheKey} data-testid="bande-magtv">
            <div class="col-12">
               <h2 class="mb-2 mb-md-3 mb-xl-3">{title}</h2>
            </div>

            <div class="col-12 col-md-6 col-lg-4">
               <div
                  class="tuile-liste header lien-composite hover-dark pb-2 pb-mb-3 h-100"
                  data-testid="magtv1"
                  data-pdb-zid={item_portrait.analytics.pdbZid}
                  data-pdb-sc={item_portrait.analytics.pdbSc}
                  data-pdb-idc={item_portrait.analytics.pdbIdc}
                  data-pdb-vi={item_portrait.analytics.pdbVi}
                  data-oevent-category={item_portrait.analytics.oeventCategory}
                  data-oevent-action={item_portrait.analytics.oeventAction}
                  data-oevent-label={item_portrait.analytics.oeventLabel}
                  data-oevent-other={item_portrait.analytics.oeventOther}
               >
                  <div class="main-wrapper pr-md-1 pt-md-1 d-flex flex-md-column h-100">
                     <div class="wrapper bg-gray2 pb-1 d-flex flex-grow-1">
                        <div
                           class="image ml-md-1 mt-md--1 mr-md--1 magtv-main-picture"
                           style={`background-image:url('${item_portrait.image}?saveas=webp&format=420x584')`}
                        ></div>
                     </div>
                     <div class="wrapper bg-gray2 px-1 pb-1 text-secondary js-magtv-thumb">
                        <strong class="category text-gray3 d-block">{item_portrait.title}</strong>
                        <h3 class="lead font-weight-bold m-0 pt-0">
                           <a class="title" href={item_portrait.URL} target={item_portrait.target} title={item_portrait.description}>
                              {item_portrait.description}
                           </a>
                        </h3>
                     </div>
                  </div>
               </div>
            </div>
            <div class="col-12 col-md-6 col-lg-4">
               <div class="row">
                  <div class="mb-2 mb-md-3 col-12">
                     <Encard {...items_landscape[0]} index="2" />
                  </div>
                  <div class="mb-2 mb-md-3 col-12">
                     <Encard {...items_landscape[1]} index="3" />
                  </div>
               </div>
            </div>
            <div class="col-12 col-lg-4">
               <div class="row">
                  <div class="mb-2 mb-md-3 col-12 col-md-6 col-lg-12">
                     <Encard {...items_landscape[2]} index="4" />
                  </div>
                  <div class="mb-2 mb-md-3 col-12 col-md-6 col-lg-12">
                     <Encard {...items_landscape[3]} index="5" />
                  </div>
               </div>
            </div>
            <div class="col-12 d-flex justify-content-center">
               <a
                  href={CTA.URL}
                  data-testid="btn-magtv-catalog"
                  class="btn btn-secondary"
                  data-pdb-zid={CTA.analytics.pdbZid}
                  data-pdb-sc={CTA.analytics.pdbSc}
                  data-pdb-idc={CTA.analytics.pdbIdc}
                  data-pdb-vi={CTA.analytics.pdbVi}
                  data-oevent-category={CTA.analytics.oeventCategory}
                  data-oevent-action={CTA.analytics.oeventAction}
                  data-oevent-label={CTA.analytics.oeventLabel}
                  data-oevent-other={CTA.analytics.oeventOther}
               >
                  {CTA.label}
               </a>
            </div>
         </div>
      </div>
   )
}

const Encard = ({ description, title, URL, image, alt, target, analytics, index }) => {
   return (
      <div
         class="tuile-liste header lien-composite hover-dark"
         data-testid={`magtv${index}`}
         data-pdb-zid={analytics.pdbZid}
         data-pdb-sc={analytics.pdbSc}
         data-pdb-idc={analytics.pdbIdc}
         data-pdb-vi={analytics.pdbVi}
         data-oevent-category={analytics.oeventCategory}
         data-oevent-action={analytics.oeventAction}
         data-oevent-label={analytics.oeventLabel}
         data-oevent-other={analytics.oeventOther}
      >
         <div class="main-wrapper pr-md-1 pt-md-1">
            <div class="wrapper bg-gray2 pb-1">
               <picture>
                  <source srcset={`${image}?format=435x218&saveas=webp`} media="(max-width: 959px)" />
                  <source srcset={`${image}?format=345x173&saveas=webp`} media="(max-width: 1199px)" />
                  <img src={`${image}?format=420x210&saveas=webp`} alt={alt} class="image ml-md-1 mt-md--1 w-md-100" loading="lazy" />
               </picture>
            </div>
            <div class="wrapper bg-gray2 px-1 pb-1 text-secondary js-magtv-thumb">
               <strong class="category standard text-gray3 d-block py-0 my-0">{title}</strong>
               <h3 class="lead font-weight-bold m-0 pt-0">
                  <a class="title" href={URL} target={target} title={description}>
                     {description}
                  </a>
               </h3>
            </div>
         </div>
      </div>
   )
}
